module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAAJ1JREFUOE9jZKACYASZcSBA8T82sxgZ/jfYb3jQSMgevIbg0/yf4b+j44YHB0BqyDaE4T/DAYeN9x1RDHHYcB9sIDkA7hKQIbjCBp/BIH2DwBBGxmsO6+9pU+SS/wyMjY4b7jWgBCapYfKPmVnHae2dq2BD9gUq2DP9Y2xgYGRwIDp2oF6hKJ3AvEKRIUz//2rbbXx0DW4I0V7AoRAA13FTD3rhUF4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/folderR.png
// module id = 417
// module chunks = 0